<template>
  <v-container fluid>
    <v-layout row>
      <v-flex class="d-flex justify-sm-center justify-md-end">
        <v-btn-toggle class="ma-2">
          <v-btn
            color="primary"
            @click="createArticle('saved')"
          >Salva</v-btn>
          <v-btn
            color="primary"
            @click="createArticle('published')"
          >Pubblica</v-btn>
          <v-btn color="primary">Programma</v-btn>
        </v-btn-toggle>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex
        md9
        xs12
        pa-2
      >
        <article-body :content="article.content"></article-body>
        <br>
        <article-seo></article-seo>
      </v-flex>
      <v-flex
        md3
        xs12
        pa-2
      >
        <article-title></article-title>
        <br>
        <article-slug></article-slug>
        <br>
        <article-cover></article-cover>
        <br>
        <article-category></article-category>
        <br>
        <article-tag></article-tag>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import ArticleTitle from './title/ArticleTitle'
  import ArticleSlug from './slug/ArticleSlug'
  import ArticleCover from './cover/ArticleCover'
  import ArticleCategory from './category/ArticleCategory'
  import ArticleTag from './tags/ArticleTag'
  import ArticleBody from './body/ArticleBody'
  import ArticleSeo from './seo/ArticleSeo'

  export default {
    name: 'ArticleCreate',
    components: {
      ArticleCover,
      ArticleTitle,
      ArticleSlug,
      ArticleBody,
      ArticleTag,
      ArticleCategory,
      ArticleSeo
    },
    data() {
      return {
        article: {}
      }
    },
    methods: {
      ...mapActions([
        'createArticle'
      ])
    },
    computed: {
      ...mapGetters([
        'newArticle'
      ])
    },
    watch: {
      newArticle: {
        handler(val) {
          console.log(val)
          this.article = val
        },
        deep: true
      }
    }
  }
</script>